import React from 'react';

const WhatsAppButton = () => {
    const phoneNumber = "919940075399";
    const message = "Hi VedhaCultures, I'm interested in your products.";
    const whatsappUrl = `https://wa.me/${phoneNumber}?text=${encodeURIComponent(message)}`;

    return (
        <a 
            href={whatsappUrl}
            target="_blank"
            rel="noopener noreferrer"
            className="whatsapp-float shadow-lg"
            title="Chat with us on WhatsApp"
            style={{
                position: 'fixed',
                width: '60px',
                height: '60px',
                bottom: '100px',
                right: '30px',
                backgroundColor: '#25d366',
                color: '#FFF',
                borderRadius: '50px',
                textAlign: 'center',
                fontSize: '30px',
                zIndex: '9999',
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                textDecoration: 'none',
                transition: 'all 0.3s ease',
                boxShadow: '0 4px 12px rgba(0,0,0,0.15)'
            }}
            onMouseOver={(e) => {
                e.currentTarget.style.transform = 'scale(1.1)';
                e.currentTarget.style.backgroundColor = '#128c7e';
            }}
            onMouseOut={(e) => {
                e.currentTarget.style.transform = 'scale(1)';
                e.currentTarget.style.backgroundColor = '#25d366';
            }}
        >
            <i className="ph-fill ph-whatsapp-logo" style={{ fontSize: '36px' }}></i>
        </a>
    );
};

export default WhatsAppButton;